import axios, { AxiosInstance } from 'axios';
import I18n from '@/i18n/I18n';
import LanguageCode from '@/language/LanguageCode';
import LanguageFactory from '@/language/LanguageFactory';

export default abstract class BaseRepository {
    private languageFactory: LanguageFactory;

    constructor() {
        this.languageFactory = new LanguageFactory();
    }

    protected client(): AxiosInstance {
        return axios.create({
            baseURL: this.baseUrl(),
        });
    }

    private baseUrl(): string | undefined {
        const isEnglish = this.languageFactory.createFrom(I18n).code === LanguageCode.EN;

        return isEnglish ? process.env.VUE_APP_API_BASE_URL_EN : process.env.VUE_APP_API_BASE_URL_NL;
    }
}
